import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useGetAllUsersQuery } from "entitites/teams/api/teamsApi";

export const UsersSelect = ({
  isMultiple,
  onChange,
  error,
  helperText,
  defaultValue,
}: {
  isMultiple?: true;
  onChange: (d: any) => void;
  error?: boolean;
  helperText?: React.ReactNode;
  defaultValue?: any;
}) => {
  const { data: users } = useGetAllUsersQuery();

  if (!users) {
    return (
      <Autocomplete
        key="1"
        size="small"
        multiple={isMultiple}
        disablePortal
        onChange={(e, value) => {
          console.log(value);
          onChange(value);
        }}
        id="employees"
        options={[]}
        sx={{ width: 400 }}
        renderInput={(params) => (
          <TextField
            error={error}
            helperText={helperText}
            {...params}
            label="Сотрудники"
          />
        )}
      />
    );
  }
  return (
    <Autocomplete
      key="2"
      disableCloseOnSelect
      defaultValue={users.find((i) => i.id === defaultValue)}
      getOptionKey={(option) => option.id}
      size="small"
      multiple={isMultiple}
      disablePortal
      onChange={(e, value) => {
        console.log(value);
        onChange(value);
      }}
      id="employees"
      getOptionLabel={(option) => option.fio}
      options={users || []}
      sx={{ width: 400 }}
      renderInput={(params) => (
        <TextField
          error={error}
          helperText={helperText}
          {...params}
          label="Сотрудники"
        />
      )}
    />
  );
};
